import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import SearchBar from '../../components/ui/SearchBar';
import MapView from './components/MapView';
import BusinessListPanel from './components/BusinessListPanel';
import MapFilters from './components/MapFilters';
import ViewToggle from './components/ViewToggle';

const InteractiveMap = () => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [mobileView, setMobileView] = useState('map');
  const [userLocation, setUserLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 43.2985, lng: 13.4531 });
  const [filters, setFilters] = useState({
    zone: 'all',
    category: 'all',
    radius: '5',
    hasPromotion: false,
    hasCashback: false,
    openNow: false
  });

  const mockBusinesses = [
  {
    id: 1,
    name: "Ristorante La Dolce Vita",
    category: "Ristoranti",
    zone: "Centro Storico",
    rating: 4.8,
    reviewCount: 127,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_192feaf14-1772570620656.png",
    imageAlt: "Elegante ristorante italiano con tavoli in legno e atmosfera calda con luci soffuse",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_166e78830-1767119315158.png",
    logoAlt: "Logo ristorante con forchetta e coltello dorati su sfondo scuro",
    address: "Via Roma 45, 62100 Macerata MC",
    lat: 43.2995,
    lng: 13.4541,
    badge: "In Evidenza",
    promotion: "Sconto 20% sul menù degustazione - Valido fino al 31/01/2026",
    hasCashback: true,
    hasPromotion: true,
    openNow: true
  },
  {
    id: 2,
    name: "Boutique Eleganza",
    category: "Moda & Abbigliamento",
    zone: "Centro Storico",
    rating: 4.6,
    reviewCount: 89,
    image: "https://images.unsplash.com/photo-1698582468284-fd9161f4176b",
    imageAlt: "Boutique moderna con vetrine illuminate e manichini che espongono abiti eleganti",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1df54c07d-1768316053988.png",
    logoAlt: "Logo boutique con lettera E stilizzata in oro su sfondo nero",
    address: "Corso della Repubblica 78, 62100 Macerata MC",
    lat: 43.2980,
    lng: 13.4525,
    badge: "Nuovo",
    promotion: null,
    hasCashback: true,
    hasPromotion: false,
    openNow: true
  },
  {
    id: 3,
    name: "Caffè Centrale",
    category: "Bar & Caffè",
    zone: "Centro Storico",
    rating: 4.7,
    reviewCount: 203,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19e7058e5-1772383753362.png",
    imageAlt: "Caffè tradizionale italiano con bancone in marmo e macchina espresso professionale",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_121f3ed4d-1773257067036.png",
    logoAlt: "Logo caffè con tazza fumante stilizzata in marrone su sfondo beige",
    address: "Piazza della Libertà 12, 62100 Macerata MC",
    lat: 43.2990,
    lng: 13.4535,
    badge: null,
    promotion: "Colazione completa a €5 - Tutti i giorni fino alle 11:00",
    hasCashback: false,
    hasPromotion: true,
    openNow: true
  },
  {
    id: 4,
    name: "Libreria Moderna",
    category: "Cultura & Tempo Libero",
    zone: "Villa Potenza",
    rating: 4.5,
    reviewCount: 67,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17d73affd-1772148291043.png",
    imageAlt: "Libreria accogliente con scaffali in legno pieni di libri e area lettura con poltrone",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ba884642-1773257072864.png",
    logoAlt: "Logo libreria con libro aperto stilizzato in blu su sfondo bianco",
    address: "Via Martiri della Libertà 156, 62100 Macerata MC",
    lat: 43.2975,
    lng: 13.4520,
    badge: null,
    promotion: null,
    hasCashback: true,
    hasPromotion: false,
    openNow: false
  },
  {
    id: 5,
    name: "Farmacia San Marco",
    category: "Salute & Benessere",
    zone: "Piediripa",
    rating: 4.9,
    reviewCount: 145,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc77b8a6-1768683532632.png",
    imageAlt: "Farmacia moderna con bancone bianco e scaffali organizzati con prodotti sanitari",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15322b741-1767950783303.png",
    logoAlt: "Logo farmacia con croce verde su sfondo bianco circolare",
    address: "Via Alcide De Gasperi 89, 62100 Macerata MC",
    lat: 43.3000,
    lng: 13.4550,
    badge: "Consigliato",
    promotion: "Cashback 10% su tutti i prodotti cosmetici",
    hasCashback: true,
    hasPromotion: true,
    openNow: true
  },
  {
    id: 6,
    name: "Pizzeria Napoli",
    category: "Ristoranti",
    zone: "Sforzacosta",
    rating: 4.4,
    reviewCount: 178,
    image: "https://images.unsplash.com/photo-1589459979016-aadbc821525c",
    imageAlt: "Pizzeria tradizionale con forno a legna e pizze appena sfornate sul bancone",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_128ebd4f3-1768054199472.png",
    logoAlt: "Logo pizzeria con fetta di pizza stilizzata in rosso e verde su sfondo bianco",
    address: "Via Sforzacosta 234, 62100 Macerata MC",
    lat: 43.2970,
    lng: 13.4515,
    badge: null,
    promotion: null,
    hasCashback: false,
    hasPromotion: false,
    openNow: true
  },
  {
    id: 7,
    name: "Parrucchiere Style",
    category: "Salute & Benessere",
    zone: "Centro Storico",
    rating: 4.7,
    reviewCount: 92,
    image: "https://images.unsplash.com/photo-1730642039597-4eed5cef4cfe",
    imageAlt: "Salone parrucchiere moderno con specchi illuminati e sedie da barbiere professionali",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_129c88fa4-1768054199183.png",
    logoAlt: "Logo parrucchiere con forbici stilizzate in argento su sfondo nero",
    address: "Via Garibaldi 23, 62100 Macerata MC",
    lat: 43.2985,
    lng: 13.4530,
    badge: null,
    promotion: "Prima visita -30% su tutti i servizi",
    hasCashback: true,
    hasPromotion: true,
    openNow: false
  },
  {
    id: 8,
    name: "Supermercato Conad",
    category: "Alimentari",
    zone: "Zona Industriale",
    rating: 4.3,
    reviewCount: 312,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5a2dab5-1764852074224.png",
    imageAlt: "Supermercato ampio con corsie organizzate e scaffali pieni di prodotti alimentari",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_11afd739a-1772126245745.png",
    logoAlt: "Logo supermercato con carrello stilizzato in verde su sfondo bianco",
    address: "Via dell'Industria 67, 62100 Macerata MC",
    lat: 43.2965,
    lng: 13.4510,
    badge: null,
    promotion: null,
    hasCashback: false,
    hasPromotion: false,
    openNow: true
  }];


  const [filteredBusinesses, setFilteredBusinesses] = useState(mockBusinesses);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation?.getCurrentPosition(
        (position) => {
          const location = {
            lat: position?.coords?.latitude,
            lng: position?.coords?.longitude
          };
          setUserLocation(location);
          setMapCenter(location);
        },
        () => {
          setUserLocation({ lat: 43.2985, lng: 13.4531 });
        }
      );
    }
  }, []);

  useEffect(() => {
    let filtered = [...mockBusinesses];

    if (filters?.zone !== 'all') {
      filtered = filtered?.filter((b) => b?.zone?.toLowerCase()?.replace(/\s+/g, '-') === filters?.zone);
    }

    if (filters?.category !== 'all') {
      filtered = filtered?.filter((b) => b?.category?.toLowerCase()?.replace(/\s+/g, '-')?.includes(filters?.category));
    }

    if (filters?.hasPromotion) {
      filtered = filtered?.filter((b) => b?.hasPromotion);
    }

    if (filters?.hasCashback) {
      filtered = filtered?.filter((b) => b?.hasCashback);
    }

    if (filters?.openNow) {
      filtered = filtered?.filter((b) => b?.openNow);
    }

    if (filters?.radius !== 'all' && userLocation) {
      const radiusKm = parseFloat(filters?.radius);
      filtered = filtered?.filter((b) => {
        const R = 6371;
        const dLat = (b?.lat - userLocation?.lat) * Math.PI / 180;
        const dLng = (b?.lng - userLocation?.lng) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(userLocation?.lat * Math.PI / 180) * Math.cos(b?.lat * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance <= radiusKm;
      });
    }

    setFilteredBusinesses(filtered);
  }, [filters, userLocation]);

  const handleBusinessSelect = (business) => {
    setSelectedBusiness(business);
    if (business) {
      setMapCenter({ lat: business?.lat, lng: business?.lng });
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleMapMove = (newCenter) => {
    setMapCenter(newCenter);
  };

  const handleFilterClick = () => {

    // Filter click handler - can be used to toggle filter panel on mobile
  };
  return (
    <>
      <Helmet>
        <title>Mappa Interattiva - Vetrine di Macerata</title>
        <meta name="description" content="Esplora le attività commerciali di Macerata sulla mappa interattiva. Trova negozi, ristoranti e servizi vicino a te con filtri avanzati e geolocalizzazione." />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header onFilterClick={handleFilterClick} />
        
        <main className="pt-16 lg:pt-16 pb-20 lg:pb-0">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-6">
            <SearchBar />
            
            <MapFilters
              onFilterChange={handleFilterChange}
              activeFilters={filters} />
            

            <div className="lg:grid lg:grid-cols-2 lg:gap-6 lg:h-[calc(100vh-280px)]">
              <div className={`${mobileView === 'map' ? 'block' : 'hidden'} lg:block h-[60vh] lg:h-full`}>
                <MapView
                  businesses={filteredBusinesses}
                  selectedBusiness={selectedBusiness}
                  onBusinessSelect={handleBusinessSelect}
                  userLocation={userLocation}
                  mapCenter={mapCenter}
                  onMapMove={handleMapMove} />
                
              </div>

              <div className={`${mobileView === 'list' ? 'block' : 'hidden'} lg:block h-[60vh] lg:h-full bg-card rounded-lg shadow-warm overflow-hidden`}>
                <BusinessListPanel
                  businesses={filteredBusinesses}
                  selectedBusiness={selectedBusiness}
                  onBusinessSelect={handleBusinessSelect}
                  userLocation={userLocation} />
                
              </div>
            </div>

            <ViewToggle
              activeView={mobileView}
              onViewChange={setMobileView} />
            
          </div>
        </main>
      </div>
    </>);

};

export default InteractiveMap;